import HistoryIcon from "@mui/icons-material/History";
import InfoIcon from "@mui/icons-material/Info";
import { Avatar, Box, ListItem, Tooltip, Typography } from "@mui/material";
import Grid from "@mui/material/Grid";
import dayjs from "dayjs";
import { useContext } from "react";
import { ConstantContext } from "components/context/ConstantProvider";
import { UserContext } from "components/context/UserProvider";
import { AsyncProcessesStatusTag } from "components/ui/atoms/Tag";
import WithConfirmationButton from "components/ui/atoms/WithConfirmationButton";

const AsyncProcessListItem = ({ automatedTask, handleRestart }) => {
  const { asyncProcessesList } = useContext(ConstantContext);
  const { hasPermission } = useContext(UserContext);

  return (
    <ListItem sx={{ flexWrap: { xs: "wrap", md: "nowrap" } }}>
      <Grid container alignItems={"center"} spacing={2} sx={{ width: "100%" }}>
        <Grid size={{ xs: 6, lg: 2 }} display={"flex"} alignItems={"center"}>
          <Tooltip title={`${automatedTask.user.fullname}`}>
            <Avatar
              alt={`${automatedTask.user.fullname}`}
              sx={{ width: 30, height: 30 }}
            >
              {automatedTask.user.initials}
            </Avatar>
          </Tooltip>
          <Typography variant="subtitle2" pl={2}>
            {
              asyncProcessesList.filter(
                (name) => name.value == automatedTask.process_code,
              )[0].label
            }
          </Typography>
        </Grid>
        <Grid size={{ xs: 6, lg: 2 }} textAlign={{ xs: "right", lg: "left" }}>
          <AsyncProcessesStatusTag status={automatedTask.status} />
        </Grid>
        <Grid size={{ xs: 6, lg: 2 }} textAlign={"left"}>
          <Box display={"flex"} flexDirection={"column"}>
            <Typography variant="body2">Created at</Typography>
            <Typography
              variant="caption"
              sx={{ color: "secondary.main" }}
              noWrap
            >
              {dayjs(automatedTask.created_at).format(
                "DD/MM/YYYY HH:mm:ss.SSS",
              )}
            </Typography>
          </Box>
        </Grid>
        <Grid size={{ xs: 6, lg: 2 }} textAlign={"left"}>
          <Box display={"flex"} flexDirection={"column"}>
            <Typography variant="body2">Updated at</Typography>
            <Typography
              variant="caption"
              sx={{ color: "secondary.main" }}
              noWrap
            >
              {dayjs(automatedTask.updated_at).format(
                "DD/MM/YYYY HH:mm:ss.SSS",
              )}
            </Typography>
          </Box>
        </Grid>
        <Grid size={{ xs: 6, lg: 1 }} textAlign={"left"}>
          <Tooltip title={JSON.stringify(automatedTask.args)}>
            <Typography
              variant="body2"
              sx={{
                color: "grey",
                display: "flex",
                alignItems: "center",
                flexWrap: "nowrap",
              }}
            >
              Arguments <InfoIcon sx={{ scale: "0.8" }} />
            </Typography>
          </Tooltip>
        </Grid>
        <Grid size={{ xs: 6, lg: 1 }} textAlign={"left"}>
          <Tooltip title={JSON.stringify(automatedTask.result)}>
            <Typography
              variant="body2"
              sx={{
                color: "grey",
                display: "flex",
                alignItems: "center",
                flexWrap: "nowrap",
              }}
            >
              Result <InfoIcon sx={{ scale: "0.8" }} />
            </Typography>
          </Tooltip>
        </Grid>
        <Grid size={{ xs: 12, lg: 2 }} textAlign={{ xs: "right" }}>
          <WithConfirmationButton
            variant="contained"
            color="primary"
            startIcon={<HistoryIcon sx={{ scale: "0.8" }} />}
            onClick={() => handleRestart(automatedTask)}
            confirmationMessage="Are you sure you want to restart the automatic task?"
            disabled={!hasPermission("app.add_asyncprocess")}
          >
            Restart
          </WithConfirmationButton>
        </Grid>
      </Grid>
    </ListItem>
  );
};

export default AsyncProcessListItem;
